<template>
    <div class="infinite-scroll">
        <slot/>
        <div>
            <button class="btn btn-info btn-block" v-if="shouldHandle" :disabled="loadingMore"
                    v-on:click="showMore" v-text="buttonText"></button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "infinite-scroll",
        props: ['shouldHandle', 'handler'],
        data: () => ({
            loadingMore: false,
            fetchMoreError: null,
        }),
        computed: {
            buttonText() {
                if (this.loadingMore) {
                    return "Loading...";
                }
                if (this.fetchMoreError) {
                    return "Failed to show more. Click to try again.";
                }
                return "Show more";
            }
        },
        mounted() {
            window.addEventListener('scroll', this.onScroll);
            window.addEventListener('resize', this.onScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
        },
        methods: {
            async showMore() {
                this.loadingMore = true;
                try {
                    await this.handler();
                    this.fetchMoreError = null;
                } catch (e) {
                    this.fetchMoreError = e;
                }
                this.loadingMore = false;
            },
            onScroll() {
                if (this.loadingMore || !this.shouldHandle || this.fetchMoreError){
                    return;
                }
                let loadMoreNow = document.documentElement.scrollTop + window.innerHeight >= this.$el.offsetTop +
                    this.$el.offsetHeight - 300;
                if (loadMoreNow) {
                    this.showMore();
                }
            }
        }
    }
</script>
